The identifier for the `CandidateProfile` that was purchased.
